const terms = {
  title: "Terms of Service",
  updated: "2026-09-15",
  intro:
    "These terms cover your use of grassurntech.com and, at a high level, how Grassurn Technologies engages with clients. They don't replace a signed statement of work or master services agreement where those exist, the signed agreement controls.",
  sections: [
    {
      heading: "The services we provide",
      body: [
        "Grassurn Technologies is an AI and innovation studio based in Toronto. We provide Strategy (AI roadmaps and architecture reviews), Build AI (end-to-end AI products and multi-agent automation), Train & Deploy (custom models, inference pipelines and AI architecture), Run at Scale (cloud, data and systems architecture) and Claude AI Enablement (turning Claude into a production capability inside a client's business).",
        "This website is informational: it describes our work, shows past case studies, and lets you get in touch or apply to a role. Paid engagements are scoped and agreed separately, in a signed statement of work.",
      ],
    },
    {
      heading: "Intellectual property",
      body: [
        "Everything on this site such as its design, code, case study write-ups, and copy, belongs to Grassurn Technologies or is used with permission, and may not be copied or republished without asking first.",
        "Grassurn Technologies retains ownership of its own pre-existing tools, frameworks, and internal methodology used to deliver client work. Ownership of client-specific deliverables is set out in the applicable statement of work, not by this page.",
      ],
    },
    {
      heading: "Acceptable use of this site",
      body: [
        "Don't attempt to scrape, reverse engineer, or overload the site, and don't try to access the admin area without authorisation. Contact-form and job-application submissions must be genuine, don't submit false information or upload a file that isn't your own resume.",
        "We may remove access or refuse further submissions from anyone who misuses the site.",
      ],
    },
    {
      heading: "Liability",
      body: [
        "This site and its content are provided as-is, without warranties of any kind. We aren't liable for indirect, incidental, or consequential damages arising from your use of the site.",
        "Liability for a paid engagement is defined in that engagement's statement of work or master services agreement, and this page does not limit or expand those terms.",
      ],
    },
    {
      heading: "Governing law",
      body: [
        "These terms are governed by the laws of the Province of Ontario and the federal laws of Canada applicable there, without regard to conflict-of-law principles. Any dispute arising from your use of this site is subject to the exclusive jurisdiction of the courts of Ontario.",
      ],
    },
  ],
};

export default terms;
